import {
  HomePageStarredEntities,
  HomePageToolkit,
  HomePageTopVisited,
  HomePageRecentlyVisited,
  FeaturedDocsCard,
  HeaderWorldClock,
  ClockConfig,
} from '@backstage/plugin-home';
import { Content, Header, Page } from '@backstage/core-components';
import { Grid, makeStyles } from '@material-ui/core';
import { AnnouncementsCard } from '@backstage-community/plugin-announcements';
import { SearchContextProvider } from '@backstage/plugin-search-react';
import { HomePageSearchBar } from '@backstage/plugin-search';
import CategoryIcon from '@material-ui/icons/Category';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import ExtensionIcon from '@material-ui/icons/Extension';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import BuildIcon from '@material-ui/icons/Build';
import BugReportIcon from '@material-ui/icons/BugReport';

const clockConfigs: ClockConfig[] = [
  {
    label: 'Madrid',
    timeZone: 'Europe/Madrid',
  },
  {
    label: 'UTC',
    timeZone: 'UTC',
  },
];

const useStyles = makeStyles(theme => ({
  searchBarInput: {
    maxWidth: '50vw',
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '50px',
    boxShadow: theme.shadows[1],
  },
  searchBarOutline: {
    borderStyle: 'none',
  },
}));

const tools = [
  {
    url: '/catalog',
    label: 'Catalog',
    icon: <CategoryIcon />,
  },
  {
    url: '/docs',
    label: 'TechDocs',
    icon: <MenuBookIcon />,
  },
  {
    url: '/api-docs',
    label: 'APIs',
    icon: <ExtensionIcon />,
  },
  {
    url: '/create',
    label: 'Templates',
    icon: <CreateNewFolderIcon />,
  },
  {
    url: '/tech-radar',
    label: 'Tech Radar',
    icon: <TrackChangesIcon />,
  },
  {
    url: 'https://monitor.aunoa.ai/jenkins',
    label: 'Jenkins',
    icon: <BuildIcon />,
  },
  {
    url: 'https://monitor.aunoa.ai/sonarqube',
    label: 'SonarQube',
    icon: <BugReportIcon />,
  },
];

export const HomePage = () => {
  const classes = useStyles();

  return (
    <SearchContextProvider>
      <Page themeId="home">
        <Header title="Developer Portal" pageTitleOverride="Home">
          <HeaderWorldClock clockConfigs={clockConfigs} />
        </Header>
        <Content>
          <Grid container justifyContent="center" spacing={3}>
            {/* Row 1: Search bar */}
            <Grid container item xs={12} justifyContent="center">
              <HomePageSearchBar
                InputProps={{
                  classes: {
                    root: classes.searchBarInput,
                    notchedOutline: classes.searchBarOutline,
                  },
                }}
                placeholder="Search..."
              />
            </Grid>
            {/* Row 2: StarredEntities, Announcements, Toolkit */}
            <Grid container item xs={12} spacing={3}>
              <Grid item xs={12} md={4}>
                <HomePageStarredEntities />
              </Grid>
              <Grid item xs={12} md={4}>
                <AnnouncementsCard max={5} />
              </Grid>
              <Grid item xs={12} md={4}>
                <HomePageToolkit tools={tools} />
              </Grid>
            </Grid>
            {/* Row 3: TopVisited, RecentlyVisited, FeaturedDocs */}
            <Grid container item xs={12} spacing={3}>
              <Grid item xs={12} md={4}>
                <HomePageTopVisited />
              </Grid>
              <Grid item xs={12} md={4}>
                <HomePageRecentlyVisited />
              </Grid>
              <Grid item xs={12} md={4}>
                <FeaturedDocsCard
                  filter={{
                    'metadata.annotations.backstage.io/techdocs-ref': 'dir:.',
                    kind: 'Component',
                    'spec.type': 'documentation',
                  }}
                  title="Documentation Highlights"
                />
              </Grid>
            </Grid>
          </Grid>
        </Content>
      </Page>
    </SearchContextProvider>
  );
};
